const module = {
  registered: false,
  namespaced: true,
  state: () => ({
    notice: {},
  }),
  getters: {
    notice: (state) => state.notice,
  },
  actions: {
    async getNotice({ commit }, key) {
      try {
        const { data } = await this.$http.get(`/contents/v1/cs/notice/${key}`)
        commit('setNotice', data)
      } catch (err) {
        console.log(err)
      }
    },
  },
  mutations: {
    setNotice(state, notice) {
      state.notice = notice
    },
  },
}

export default module
